export const GET_CHARGE_DASHBOARD_10_MINUTAL_PRO =
  'GET_CHARGE_DASHBOARD_10_MINUTAL_PRO';
export const GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_SUCCESS =
  'GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_SUCCESS';
export const GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_FAILURE =
  'GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_FAILURE';
export const GET_CHARGE_DASHBOARD_5_MINUTAL_PRO =
  'GET_CHARGE_DASHBOARD_5_MINUTAL_PRO';
export const GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_SUCCESS =
  'GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_SUCCESS';
export const GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_FAILURE =
  'GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_FAILURE';
export const GET_CHARGE_DASHBOARD_HARMONIC_PRO =
  'GET_CHARGE_DASHBOARD_HARMONIC_PRO';
export const GET_CHARGE_DASHBOARD_HARMONIC_PRO_SUCCESS =
  'GET_CAHRGE_DASHBOARD_HARMONIC_PRO_SUCCESS';
export const GET_CHARGE_DASHBOARD_HARMONIC_PRO_FAILURE =
  'GET_CAHRGE_DASHBOARD_HARMONIC_PRO_FAILURE';
export const GET_CHARGE_PRO_REPORT_SUCCESS = 'GET_CHARGE_PRO_REPORT_SUCCESS';
export const GET_CHARGE_PRO_REPORT_FAILURE = 'GET_CHARGE_PRO_REPORT_FAILURE';
export const GET_CHARGE_PRO_REPORT = 'GET_CHARGE_PRO_REPORT';
export const GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_SUCCESS =
  'GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_SUCCESS';
export const GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_FAILURE =
  'GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_FAILURE';
export const GET_CHARGE_DASHBOARD_NOTIFICATION_SUCCESS =
  'GET_CHARGE_DASHBOARD_NOTIFICATION_SUCCESS';
export const GET_CHARGE_DASHBOARD_NOTIFICATION_FAILURE =
  'GET_CHARGE_DASHBOARD_NOTIFICATION_FAILURE';
export const GET_CHARGE_PRO_REPORT_PDF_SUCCESS =
  'GET_CHARGE_PRO_REPORT_PDF_SUCCESS';
export const GET_CHARGE_PRO_REPORT_PDF_FAILURE =
  'GET_CHARGE_PRO_REPORT_PDF_FAILURE';
